var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#360905",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    d: "m21 21-4.343-4.343m0 0A8 8 0 1 0 5.344 5.344a8 8 0 0 0 11.313 11.313"
  })));
};
export default SvgSearch;